export default __webpack_public_path__ + "img/filter_VT.ae31ee326069a71e1cb05d1acecf2ab8.jpg";